import { routerWith } from "router";

import { router as chatRouter, routes as chatRoutes } from "../views-new/chat/router";
import { router as companyRouter, routes as companyRoutes } from "../views-new/companies/router";
import { router as dashboardRouter, routes as dashboardRoutes } from "../views-new/dashboard/router";
import { router as notificationsRouter, routes as notificationsRoutes } from "../views-new/notifications/router";
import { router as adminInvitationsRouter, routes as adminInvitationsRoutes } from "./AdminInvitations/router";
import { router as assignmentsRouter, routes as assignmentsRoutes } from "./Assignments/router";
import {
  publicRouter as clientPublicRouter,
  publicRoutes as clientPublicRoutes,
  router as clientRouter,
  routes as clientRoutes,
} from "./Clients/router";
import {
  router as consultantInvitationsRouter,
  routes as consultantInvitationsRoutes,
} from "./ConsultantInvitations/router";
import { router as consultantProfilesRouter, routes as consultantProfilesRoutes } from "./ConsultantProfiles/router";
import { router as contractsRouter, routes as contractRoutes } from "./Contracts/router";
import { router as jobApplicationsRouter, routes as jobApplicationsRoutes } from "./job-applications/router";
import { router as jobRequestsPageRouter, routes as jobRequestsRoutes } from "./JobRequests/router";
import { router as landingPageRouter, routes as landingPageRoutes } from "./Landing/router";
import { router as managerInvitationsRouter, routes as managerInvitationsRoutes } from "./ManagerInvitations/router";
import { router as onboardingRouter, routes as onboardingRoutes } from "./Onboarding/router";
import { router as personalInvitationsRouter, routes as personalInvitationsRoutes } from "./PersonalInvitations/router";
import { router as sessionRouter, routes as sessionRoutes } from "./Session/router";
import { router as usersRouter, routes as usersRoutes } from "./Settings/router";
import { router as tasksRouter, routes as tasksRoutes } from "./Tasks/router";
import { router as timeReportsRouter, routes as timeReportsRoutes } from "./time-reports/router";
import { router as workOrdersRouter, routes as workOrdersRoutes } from "./WorkOrders/router";

export const routes = [
  ...adminInvitationsRoutes,
  ...assignmentsRoutes,
  ...clientRoutes,
  ...clientPublicRoutes,
  ...companyRoutes,
  ...consultantInvitationsRoutes,
  ...consultantProfilesRoutes,
  ...jobApplicationsRoutes,
  ...jobRequestsRoutes,
  ...landingPageRoutes,
  ...managerInvitationsRoutes,
  ...onboardingRoutes,
  ...personalInvitationsRoutes,
  ...sessionRoutes,
  ...usersRoutes,
  ...dashboardRoutes,
  ...workOrdersRoutes,
  ...tasksRoutes,
  ...notificationsRoutes,
  ...timeReportsRoutes,
  ...chatRoutes,
  ...contractRoutes,
];

export const router = routerWith([
  adminInvitationsRouter,
  assignmentsRouter,
  clientRouter,
  clientPublicRouter,
  companyRouter,
  consultantInvitationsRouter,
  consultantProfilesRouter,
  jobApplicationsRouter,
  jobRequestsPageRouter,
  landingPageRouter,
  managerInvitationsRouter,
  onboardingRouter,
  personalInvitationsRouter,
  sessionRouter,
  usersRouter,
  dashboardRouter,
  workOrdersRouter,
  tasksRouter,
  notificationsRouter,
  timeReportsRouter,
  chatRouter,
  contractsRouter,
]);
